const SubAbas = [{ label: 'Pauta', rota: '/fornecedor/pautas/pautas' }];

export default SubAbas;
